export default __webpack_public_path__ + "static/media/sandwich.3880b208.jpg";